<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Paint Bucket" class="d-icon d-icon--paint-bucket" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M2.646.646a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 1 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708ZM9.496 5.5a.5.5 0 0 1 0 1H1.021a.5.5 0 1 1 0-1h8.475Zm.503 2.25a.5.5 0 0 1 .49.396c.056.257.196.489.4.657l.134.119c.294.287.475.649.477 1.06l-.006.148a1.5 1.5 0 0 1-.427.924 1.503 1.503 0 0 1-2.134 0A1.5 1.5 0 0 1 8.5 9.98c.002-.461.231-.873.611-1.178l.075-.066a1.15 1.15 0 0 0 .325-.59.5.5 0 0 1 .488-.397ZM10 9.33a2.227 2.227 0 0 1-.257.247l-.003.003c-.19.153-.24.298-.24.407v.007a.503.503 0 0 0 .308.467.499.499 0 0 0 .692-.467v-.007c0-.108-.048-.25-.243-.41h-.002A2.168 2.168 0 0 1 10 9.328Z" fill="currentColor"/><path d="M9.5 5.25a.103.103 0 0 0-.03-.073L5.822 1.53a.103.103 0 0 0-.146 0L4.604 2.603a.5.5 0 1 1-.707-.707L4.97.823a1.103 1.103 0 0 1 1.56 0l3.647 3.647a1.103 1.103 0 0 1 0 1.56L6.38 9.826a2.309 2.309 0 0 1-3.263 0L1.174 7.88a2.308 2.308 0 0 1 0-3.262L2.48 3.31a.5.5 0 0 1 .708.707L1.88 5.326a1.307 1.307 0 0 0 0 1.848L3.825 9.12a1.308 1.308 0 0 0 1.849 0L9.47 5.323a.106.106 0 0 0 .03-.073Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconPaintBucket',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
